import { render, staticRenderFns } from "./newPdf.vue?vue&type=template&id=3906b446&scoped=true"
import script from "./newPdf.vue?vue&type=script&lang=js"
export * from "./newPdf.vue?vue&type=script&lang=js"
import style0 from "./newPdf.vue?vue&type=style&index=0&id=3906b446&lang=css"
import style1 from "./newPdf.vue?vue&type=style&index=1&id=3906b446&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906b446",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3906b446')) {
      api.createRecord('3906b446', component.options)
    } else {
      api.reload('3906b446', component.options)
    }
    module.hot.accept("./newPdf.vue?vue&type=template&id=3906b446&scoped=true", function () {
      api.rerender('3906b446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/newPdf.vue"
export default component.exports